"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import ExceptionItem from "./document_exception_item";
import ReactUtils from "../../react_utils";
import ExceptionSender from "../exception_sender";
import Api from "../../api/api";
import Auth from "../../util/auth";
import LoadEmailCreator from "../load_email_creator";
import OutgoingEmailSignature from "../../helpers/outgoing_email_signature";
import NewException, { DOCUMENTS_CONTEXT } from "./new_exception";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import { History } from "react-router";
import { Flash } from "../../components/flash";
var bem = ReactUtils.makeBem("document_exception_area");
function ignoredMessage(props) {
  if (props.documentGroup.ignored) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, "This group is ignored");
  }
}
function continueProcessing(props) {
  props.closeExceptions();
}
function renderEmailTemplate(props, subjectTemplate, bodyTemplate) {
  var _a;
  const invoiceForTemplate = {
    exception_events: props.exceptions || [],
    failure_messages: []
  };
  return new LoadEmailCreator(
    props.selectedLoad,
    invoiceForTemplate,
    Auth._currentUser,
    subjectTemplate,
    bodyTemplate,
    ((_a = Api.Account.current()) == null ? void 0 : _a.payables_template_variables) || [],
    props.carrier,
    { blankMissing: true }
  ).initialEmail();
}
function emailProps(props, settings) {
  var _a;
  if (!settings.prefill_document_group_exception_emails) {
    return {
      defaultEmail: { body: OutgoingEmailSignature.signatureWithBuffer() }
    };
  }
  return {
    defaultEmail: renderEmailTemplate(
      props,
      settings.custom_exception_email_subject_template,
      settings.custom_exception_email_body_template
    ),
    renderTemplate: (subject, body) => renderEmailTemplate(props, subject, body),
    possibleLoad: props.selectedLoad,
    multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
    customEmailTemplates: settings.custom_exception_email_templates,
    templateVariables: (_a = Api.Account.current()) == null ? void 0 : _a.payables_template_variables
  };
}
export default React.createClass({
  mixins: [History],
  getInitialState: function() {
    return { saving: false };
  },
  // STATE
  startSendingEmail: function() {
    this.setState({
      sendingEmail: true,
      ignored: this.props.documentGroup.ignored
    });
  },
  cancelSendingEmail: function() {
    this.props.scrollUp();
    this.setState({ sendingEmail: false });
  },
  sendComplete: function() {
    this.props.scrollUp();
    this.setState({ sendingEmail: false, messageSent: true });
  },
  // RENDER
  render: function() {
    var exception = _.first(this.props.exceptions);
    if (this.state.recentlyResolved || exception) {
      return this.existingExceptionArea(exception);
    } else {
      return this.newExceptionArea();
    }
  },
  addResolutionMessageOption: function() {
    if (this.state.recentlyResolved && !this.state.addingResolutionMessage) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-exception-area-resolution-message-options" }, /* @__PURE__ */ React.createElement("h4", null, " The exception has been removed. "), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--secondary",
          onClick: this.startAddingResolutionMessage
        },
        "Add Resolution Message"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: bem("__continue-processing-button") + " button--progress",
          onClick: () => continueProcessing(this.props)
        },
        "Continue Processing"
      ));
    }
  },
  startAddingResolutionMessage: function() {
    this.setState({ addingResolutionMessage: true });
  },
  saveResolutionMessageButton: function() {
    return /* @__PURE__ */ React.createElement("button", { className: "button--progress", onClick: this.saveResolutionMessage }, "Save");
  },
  saveResolutionMessage: function() {
    this.setState({ saving: true });
    this.props.exceptionUpdater(
      this.state.resolutionMessage,
      this.state.exception,
      this.props.documentGroup
    ).then(() => {
      Flash.success("The resolution message was added!");
      this.props.closeExceptions();
    });
  },
  addResolutionMessageDialogue: function() {
    if (this.state.addingResolutionMessage) {
      return /* @__PURE__ */ React.createElement("div", { className: "rules__resolve-exception-container" }, /* @__PURE__ */ React.createElement(
        "textarea",
        {
          placeholder: "Resolution Message",
          rows: 4,
          value: this.state.resolutionMessage || "",
          onChange: (e) => this.setState({
            resolutionMessage: e.target.value
          })
        }
      ), this.saveResolutionMessageButton(), /* @__PURE__ */ React.createElement("span", { className: "button__cancel-wrapper" }, " ", /* @__PURE__ */ React.createElement("span", { className: "button__cancel-wrapper-or" }, "or"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--cancel",
          onClick: this.cancelAddingResolutionmessage
        },
        "cancel"
      )));
    }
  },
  cancelAddingResolutionmessage: function() {
    this.setState({ addingResolutionMessage: false });
  },
  recentlyResolved: function(exception) {
    this.setState({ recentlyResolved: true, exception });
    this.props.recentlyResolved();
  },
  existingExceptionArea: function(exception) {
    if (this.state.recentlyResolved) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-exception-area-wrapper" }, this.addResolutionMessageOption(), this.addResolutionMessageDialogue());
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "document-exception-area-wrapper" }, ignoredMessage(this.props), /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, "The following exceptions were reported for this document group:"), /* @__PURE__ */ React.createElement("ul", { className: "rules__list" }, /* @__PURE__ */ React.createElement(
        ExceptionItem,
        {
          exception,
          recentlyResolved: this.recentlyResolved,
          exceptionResolver: this.props.exceptionResolver,
          owner: this.props.documentGroup
        }
      )), /* @__PURE__ */ React.createElement("div", { className: bem("__email-buttons") }, this.sendEmailButtonOrSender(exception), this.possibleDashboardOrNextGroupButton()));
    }
  },
  sendEmailButtonOrSender: function(exception) {
    if (this.state.sendingEmail) {
      const settings = Api.Account.currentSettings() || {};
      return /* @__PURE__ */ React.createElement(
        ExceptionSender,
        __spreadProps(__spreadValues({
          documents: this.props.model.activeDocuments(),
          onComplete: this.sendComplete,
          ignored: this.state.ignored,
          messageSent: this.state.messageSent,
          canCancel: true,
          cancel: this.cancelSendingEmail
        }, emailProps(this.props, settings)), {
          documentGroupId: this.props.documentGroup.id,
          parent: this.props.email,
          hasMore: this.props.hasMore,
          toDashboardOrNextGroup: this.toDashboardOrNextGroup,
          contacts: this.props.carrier.contacts
        })
      );
    } else {
      if (this.state.messageSent) {
        return /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.startSendingEmail,
            className: "button--secondary"
          },
          "Message Sent. Send Another"
        );
      } else {
        return /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.startSendingEmail,
            className: "button--confirmation"
          },
          "Send Message"
        );
      }
    }
  },
  possibleDashboardOrNextGroupButton: function() {
    if (this.props.hasMore) {
      var buttonText = "Go To Next Group";
    } else {
      var buttonText = "Return To Dashboard";
    }
    if (this.state.messageSent && !this.state.sendingEmail) {
      return /* @__PURE__ */ React.createElement("div", { className: bem("__dashboard-or-next-group-button-container") }, /* @__PURE__ */ React.createElement("span", { className: "button__cancel-wrapper-or" }, "or"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: bem("__dashboard-or-next-group-button") + " button--progress",
          onClick: this.toDashboardOrNextGroup
        },
        buttonText
      ));
    }
  },
  toDashboardOrNextGroup: function() {
    if (this.props.hasMore) {
      this.props.documentsExceptionAddedCallback();
    } else {
      ToDashboardWithFilters(this.props.location, this.history);
    }
  },
  newExceptionArea: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "document-exception-area-wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, "Create an exception for this document group: (ex. Unable to find load in TriumphPay Audit, Documents belong to a different broker)"), /* @__PURE__ */ React.createElement(
      NewException,
      {
        exceptionCreator: this.props.exceptionCreator,
        context: DOCUMENTS_CONTEXT,
        documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
        startSendEmail: this.startSendingEmail,
        location: this.props.location,
        group: this.props.documentGroup,
        groups: this.props.model.groups,
        hasMore: this.props.hasMore,
        onCancel: this.props.onCancel
      }
    ));
  }
});
